// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
var options={
  fullscreenEl:false, //关闭全屏按钮
  closeEl:false,
  zoomEl: false,
  // counterEl: false,
  preloaderEl: true,
  tapToToggleControls: true,
  captionEl: true,
  tapToClose: true
}
Vue.use(preview,options)

import Component from './components'

import axios from './utils/axios'

import { Toast,  Field, Cell, Popup, Picker, DatetimePicker, Search, Dialog,List  } from 'vant';
Vue.use(Field).use(Cell).use(Search).use(Popup).use(Picker).use(DatetimePicker).use(Toast).use(Dialog).use(List);
Component(Vue);
import { Slider } from 'vant';
Vue.use(Slider);

import 'lib-flexible/flexible'
Vue.config.productionTip = false
import Data from './store/index'
Vue.prototype.storeData = Data;

Vue.prototype.$axios = axios;

import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer)

import VueLazyLoad from 'vue-lazyload'
Vue.use(VueLazyLoad,{
  preLoad: 4,
  attempt: 3,
  loading: 'http://dudao.tianwangwatch.cn/loading.gif'
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  data:{
      center: new Vue()
  },
  components: { App, Component },
  template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js